import { VideoJsPlayer } from '@app/modules/logger/screens/stream/modes/video/video-js/VideoJsPlayer';
import { Box, Typography } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const videoPreviewTitleMessage = defineMessage({
  id: 'fragments.socialExport.videoPreview.title',
  defaultMessage: 'Vista previa del video',
});

export interface SocialExportVideoPreviewProps {
  /** URL of the video to display. When empty, nothing is rendered. */
  videoUrl: string | null;
}

/**
 * Displays a preview of the video that will be uploaded to the social platform.
 * Shown alongside the publish form so the user can confirm the correct media.
 */
export function SocialExportVideoPreview({ videoUrl }: SocialExportVideoPreviewProps) {
  if (!videoUrl) {
    return null;
  }

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        <FormattedMessage {...videoPreviewTitleMessage} />
      </Typography>
      <Box sx={{ borderRadius: 1, overflow: 'hidden', bgcolor: 'action.hover' }}>
        <VideoJsPlayer bordered src={videoUrl} sx={{ width: '100%', maxWidth: 1 }} />
      </Box>
    </Box>
  );
}
